export default "__VITE_ASSET__40846493__"